import React from "react";
import {Form, Select, Input,Upload,InputNumber,Button,Icon,message} from 'antd';
import NHFormItem from '../../common/NHFormItem/index';
import NHSelect from "../../common/NHSelect";
import {createUuid} from '../../../utils/NHCore';

const FormItem = Form.Item;
const uploadUrl = "api/zhxg-yxxt/fwwgl/sytp/uploadPicture"; //上传logo路径
const getPicUrl = "api/zhxg-yxxt/fwwgl/sytp/getPicture/";//获取图片路径
function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
}

function beforeUpload(file) {
    const isJPG = file.type === 'image/jpeg';
    const isPNG = file.type === 'image/png';
    const limit1M = file.size / 1024 / 1024 < 1;
    if (!limit1M) {
        message.error('上传图片不能大于1MB!');
    }
    if (!isJPG && !isPNG) {
        message.error('只能上传JPG和PNG格式的图片!');
    }
    return ((isJPG || isPNG) && limit1M);
}

class EditInitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            imageUrl: null,
            uuid: null,
        }
    }

    handleChange = (info) => {
        if (info.file.status === 'uploading') {
            this.setState({ loading: true });
            return;
        }
        if (info.file.status === 'done') {
            getBase64(info.file.originFileObj, imageUrl => this.setState({
                imageUrl,
                loading: false,
            }));

            let response = info.file.response;
            if(response.code==200){
                this.setState({uuid:info.file.response.data});
            }else{
                message.warn('图片上传失败，请重新添加!');
            }
        }
    }


    render() {       
        const {form, initFormData} = this.props;
        const uploadButton = (
            <Button>
                <Icon type="upload" />点击上传图片
            </Button>
        );
        return (
            <div>
                <Form layout="horizontal">
                    <NHFormItem id={'tpmc'} label={'图片名称'} hasFeedback={true} form={form} required={true}
                                pattern={{max: 100, message: "图片名称长度不能超过100字符！"}}
                                initialValue={initFormData ? initFormData.tpmc : ''}>
                        <Input placeholder="请输入图片名称"/>
                    </NHFormItem>
                    <NHFormItem id={'zt'} label={'是否启用'} hasFeedback={true} form={form} required={true}
                        initialValue={initFormData ? initFormData.zt:'1'}>
                        <Select placeholder={'请选择类型'}>
                            <Select.Option key={'0'}>停用</Select.Option>
                            <Select.Option key={'1'}>启用</Select.Option>
                        </Select>
                    </NHFormItem>   
                    <NHFormItem id={'pxh'} label={'排序号'} hasFeedback={true} form={form}
                                initialValue={initFormData ? initFormData.pxh : 1}>
                        <InputNumber/>
                    </NHFormItem>   

                    <NHFormItem label={'上传图片'}  hasFeedback={true} form={form} required={true}
                        initialValue={initFormData ? 0 : ''}>   
                        <div>               
                            <Upload
                                showUploadList={false}
                                action={uploadUrl}
                                beforeUpload={beforeUpload}
                                onChange={this.handleChange}
                            >   
                                     
                            {((this.state.imageUrl) || (initFormData)) ?
                                <img style={{maxWidth:'600px'}}
                                src={this.state.imageUrl ? this.state.imageUrl :(getPicUrl+initFormData.pkid+'?uuid='+createUuid()) } alt=""/> : uploadButton}
                                                    
                            </Upload>                              
                        </div>                        
                    </NHFormItem>

                    <NHFormItem id={'uuid'} form={form}
                                initialValue={this.state.uuid}>
                        <Input type = "hidden"/>
                    </NHFormItem> 
                </Form>
            </div>
        );
    }
}


const EditForm = Form.create()(EditInitForm);

export default EditForm;


// WEBPACK FOOTER //
// ./components/fwwgl/sytp/EditForm.js